module.exports = __webpack_public_path__ + "static/cover_mobile-a6dfbccdb75a7f42fe6c997a52734c69.mp4";